import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { resetStoreSpecificState } from "@/store/actions/storeActions";

export interface WalletState {
  loaded: boolean;
  loading: boolean;
  error?: string | null;
  balance: {
    balance: number;
    pendingBalance: number;
  } | null;
  transactions: any[];
  total: number;
}

const initialState: WalletState = {
  loaded: false,
  loading: false,
  error: null,
  balance: null,
  transactions: [],
  total: 0,
};

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    setWalletData: (
      state,
      action: PayloadAction<{
        balance: { balance: number; pendingBalance: number } | null;
        transactions: any[];
        total?: number;
      }>,
    ) => {
      state.balance = action.payload.balance;
      state.transactions = action.payload.transactions || [];
      state.total = action.payload.total || 0;
      state.loaded = true;
      state.loading = false;
      state.error = null;
    },
    clearWallet: (state) => {
      state.loaded = false;
      state.loading = false;
      state.error = null;
      state.balance = null;
      state.transactions = [];
      state.total = 0;
    },
    setWalletLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setWalletError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStoreSpecificState, () => initialState);
  },
});

export const { setWalletData, clearWallet, setWalletLoading, setWalletError } =
  walletSlice.actions;

export default walletSlice.reducer;
